import React from 'react';
import LoadingSpinner from '../LoadingSpinner';

const BlogListingFallback = () => (
  <div className="min-h-screen bg-neutral-50">
    <div className="flex items-center justify-center min-h-screen">
      <LoadingSpinner />
    </div>
  </div>
);

export default BlogListingFallback; 